module.exports = "<app-sidebar></app-sidebar>"